import * as Mod1 from "./discourse/components/admin-dashboard-card";
import * as Mod2 from "./discourse/components/code-view";
import * as Mod3 from "./discourse/components/data-explorer-chart";
import * as Mod4 from "./discourse/components/explorer-schema";
import * as Mod5 from "./discourse/components/explorer-schema/enum-info";
import * as Mod6 from "./discourse/components/explorer-schema/one-table";
import * as Mod7 from "./discourse/components/modal/query-help";
import * as Mod8 from "./discourse/components/param-input-form";
import * as Mod9 from "./discourse/components/param-input/boolean-three";
import * as Mod10 from "./discourse/components/param-input/category-id-input";
import * as Mod11 from "./discourse/components/param-input/group-input";
import * as Mod12 from "./discourse/components/param-input/user-id-input";
import * as Mod13 from "./discourse/components/param-input/user-list-input";
import * as Mod14 from "./discourse/components/query-ai-prompt";
import * as Mod15 from "./discourse/components/query-chart-empty-state";
import * as Mod16 from "./discourse/components/query-mode-switch";
import * as Mod17 from "./discourse/components/query-result-download-buttons";
import * as Mod18 from "./discourse/components/query-result";
import * as Mod19 from "./discourse/components/query-results-wrapper";
import * as Mod20 from "./discourse/components/query-row-content";
import * as Mod21 from "./discourse/components/query-run-split-button";
import * as Mod22 from "./discourse/components/result-types/badge";
import * as Mod23 from "./discourse/components/result-types/category";
import * as Mod24 from "./discourse/components/result-types/group";
import * as Mod25 from "./discourse/components/result-types/html";
import * as Mod26 from "./discourse/components/result-types/json";
import * as Mod27 from "./discourse/components/result-types/post";
import * as Mod28 from "./discourse/components/result-types/reltime";
import * as Mod29 from "./discourse/components/result-types/tag-group";
import * as Mod30 from "./discourse/components/result-types/text";
import * as Mod31 from "./discourse/components/result-types/topic";
import * as Mod32 from "./discourse/components/result-types/url";
import * as Mod33 from "./discourse/components/result-types/user";
import * as Mod34 from "./discourse/components/share-report";
import * as Mod35 from "./discourse/connectors/admin-dashboard-manage-reports-footer/data-explorer-hint.gjs";
import * as Mod36 from "./discourse/connectors/group-reports-nav-item/nav-item.gjs";
import * as Mod37 from "./discourse/controllers/admin-plugins/show/explorer";
import * as Mod38 from "./discourse/controllers/admin-plugins/show/explorer/edit";
import * as Mod39 from "./discourse/controllers/admin-plugins/show/explorer/index";
import * as Mod40 from "./discourse/controllers/admin-plugins/show/explorer/new";
import * as Mod41 from "./discourse/controllers/group/reports";
import * as Mod42 from "./discourse/controllers/group/reports/index";
import * as Mod43 from "./discourse/controllers/group/reports/show";
import * as Mod44 from "./discourse/explorer-legacy-route-map";
import * as Mod45 from "./discourse/explorer-route-map";
import * as Mod46 from "./discourse/group-reports-route-map";
import * as Mod47 from "./discourse/initializers/data-explorer-admin-plugin-configuration-nav";
import * as Mod48 from "./discourse/initializers/initialize-data-explorer";
import * as Mod49 from "./discourse/initializers/register-admin-dashboard-renderer";
import * as Mod50 from "./discourse/lib/ai-generation";
import * as Mod51 from "./discourse/lib/chart-helpers";
import * as Mod52 from "./discourse/lib/constants";
import * as Mod53 from "./discourse/lib/themeColor";
import * as Mod54 from "./discourse/models/query";
import * as Mod55 from "./discourse/routes/admin-plugins/explorer";
import * as Mod56 from "./discourse/routes/admin-plugins/explorer/index";
import * as Mod57 from "./discourse/routes/admin-plugins/explorer/queries";
import * as Mod58 from "./discourse/routes/admin-plugins/explorer/queries/edit";
import * as Mod59 from "./discourse/routes/admin-plugins/explorer/queries/index";
import * as Mod60 from "./discourse/routes/admin-plugins/show/explorer";
import * as Mod61 from "./discourse/routes/admin-plugins/show/explorer/edit";
import * as Mod62 from "./discourse/routes/admin-plugins/show/explorer/index";
import * as Mod63 from "./discourse/routes/admin-plugins/show/explorer/new";
import * as Mod64 from "./discourse/routes/group/reports";
import * as Mod65 from "./discourse/routes/group/reports/index";
import * as Mod66 from "./discourse/routes/group/reports/show";
import * as Mod67 from "./discourse/templates/group/reports";
import * as Mod68 from "./discourse/templates/group/reports/index";
import * as Mod69 from "./discourse/templates/group/reports/show";
const compatModules = {
  "discourse/components/admin-dashboard-card": Mod1,
  "discourse/components/code-view": Mod2,
  "discourse/components/data-explorer-chart": Mod3,
  "discourse/components/explorer-schema": Mod4,
  "discourse/components/explorer-schema/enum-info": Mod5,
  "discourse/components/explorer-schema/one-table": Mod6,
  "discourse/components/modal/query-help": Mod7,
  "discourse/components/param-input-form": Mod8,
  "discourse/components/param-input/boolean-three": Mod9,
  "discourse/components/param-input/category-id-input": Mod10,
  "discourse/components/param-input/group-input": Mod11,
  "discourse/components/param-input/user-id-input": Mod12,
  "discourse/components/param-input/user-list-input": Mod13,
  "discourse/components/query-ai-prompt": Mod14,
  "discourse/components/query-chart-empty-state": Mod15,
  "discourse/components/query-mode-switch": Mod16,
  "discourse/components/query-result-download-buttons": Mod17,
  "discourse/components/query-result": Mod18,
  "discourse/components/query-results-wrapper": Mod19,
  "discourse/components/query-row-content": Mod20,
  "discourse/components/query-run-split-button": Mod21,
  "discourse/components/result-types/badge": Mod22,
  "discourse/components/result-types/category": Mod23,
  "discourse/components/result-types/group": Mod24,
  "discourse/components/result-types/html": Mod25,
  "discourse/components/result-types/json": Mod26,
  "discourse/components/result-types/post": Mod27,
  "discourse/components/result-types/reltime": Mod28,
  "discourse/components/result-types/tag-group": Mod29,
  "discourse/components/result-types/text": Mod30,
  "discourse/components/result-types/topic": Mod31,
  "discourse/components/result-types/url": Mod32,
  "discourse/components/result-types/user": Mod33,
  "discourse/components/share-report": Mod34,
  "discourse/connectors/admin-dashboard-manage-reports-footer/data-explorer-hint": Mod35,
  "discourse/connectors/group-reports-nav-item/nav-item": Mod36,
  "discourse/controllers/admin-plugins/show/explorer": Mod37,
  "discourse/controllers/admin-plugins/show/explorer/edit": Mod38,
  "discourse/controllers/admin-plugins/show/explorer/index": Mod39,
  "discourse/controllers/admin-plugins/show/explorer/new": Mod40,
  "discourse/controllers/group/reports": Mod41,
  "discourse/controllers/group/reports/index": Mod42,
  "discourse/controllers/group/reports/show": Mod43,
  "discourse/explorer-legacy-route-map": Mod44,
  "discourse/explorer-route-map": Mod45,
  "discourse/group-reports-route-map": Mod46,
  "discourse/initializers/data-explorer-admin-plugin-configuration-nav": Mod47,
  "discourse/initializers/initialize-data-explorer": Mod48,
  "discourse/initializers/register-admin-dashboard-renderer": Mod49,
  "discourse/lib/ai-generation": Mod50,
  "discourse/lib/chart-helpers": Mod51,
  "discourse/lib/constants": Mod52,
  "discourse/lib/themeColor": Mod53,
  "discourse/models/query": Mod54,
  "discourse/routes/admin-plugins/explorer": Mod55,
  "discourse/routes/admin-plugins/explorer/index": Mod56,
  "discourse/routes/admin-plugins/explorer/queries": Mod57,
  "discourse/routes/admin-plugins/explorer/queries/edit": Mod58,
  "discourse/routes/admin-plugins/explorer/queries/index": Mod59,
  "discourse/routes/admin-plugins/show/explorer": Mod60,
  "discourse/routes/admin-plugins/show/explorer/edit": Mod61,
  "discourse/routes/admin-plugins/show/explorer/index": Mod62,
  "discourse/routes/admin-plugins/show/explorer/new": Mod63,
  "discourse/routes/group/reports": Mod64,
  "discourse/routes/group/reports/index": Mod65,
  "discourse/routes/group/reports/show": Mod66,
  "discourse/templates/group/reports": Mod67,
  "discourse/templates/group/reports/index": Mod68,
  "discourse/templates/group/reports/show": Mod69,
};
export default compatModules;
